import { Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CalendarRange } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { PageHeader } from '@/components/efs/PageHeader';
import { useBatchContext } from '@/app/BatchContext';

interface BatchShortcutPageProps {
  template: string;
}

export const BatchShortcutPage = ({ template }: BatchShortcutPageProps) => {
  const { t } = useTranslation();
  const { batchId } = useBatchContext();

  if (batchId) {
    return <Navigate to={template.replace(':id', batchId)} replace />;
  }

  return (
    <div className="space-y-4">
      <PageHeader
        title={t('efs.common.batch_shortcut.title')}
        subtitle={t('efs.common.batch_shortcut.subtitle')}
      />
      <Alert>
        <CalendarRange className="h-4 w-4" />
        <AlertTitle>{t('efs.common.messages.no_batch_selected')}</AlertTitle>
        <AlertDescription>{t('efs.common.batch_shortcut.description')}</AlertDescription>
      </Alert>
      <Button asChild>
        <Link to="/batches">
          <CalendarRange className="mr-1 h-4 w-4" />
          {t('efs.common.batch_shortcut.open_batches')}
        </Link>
      </Button>
    </div>
  );
};

export default BatchShortcutPage;
